class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    if (parsedState.id) this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    // Sync cart store type and apply Astro theme if needed
    if (parsedState && parsedState.items) {
      syncCartStoreType(parsedState.items);
    }

    // Handle progress bar update after rendering (using global function)
    if (parsedState && typeof updateFreeGiftProgressBar === 'function') {
        updateFreeGiftProgressBar(parsedState);
    }

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

/* ─── Cart Store Type Helpers ─── */
function getCartStoreType(items) {
  if (!items || !items.length) return 'main';
  const hasAstro = items.some(function(item) {
    return (
      (item.properties && (item.properties._astro_store === 'true' || item.properties['_astro_store'] === 'true')) ||
      item.product_type === 'astro-store'
    );
  });
  return hasAstro ? 'astro' : 'main';
}

function syncCartStoreType(items) {
  var storeType = getCartStoreType(items);
  if (!items || !items.length) {
    var isAstroPage = document.body.dataset.storeType === 'astro' || document.body.classList.contains('astro-store-theme');
    storeType = isAstroPage ? 'astro' : 'main';
  }
  try { localStorage.setItem('cartStoreType', storeType); } catch(e) {}

  var cartDrawerEl = document.querySelector('cart-drawer');
  if (!cartDrawerEl) return;

  var hasAstro = storeType === 'astro';
  cartDrawerEl.dataset.hasAstroItems = hasAstro ? 'true' : 'false';

  var headingEl = cartDrawerEl.querySelector('.drawer__heading');
  var headerEl = cartDrawerEl.querySelector('.drawer__header');
  if (headingEl) {
    if (hasAstro) {
      headingEl.textContent = 'Astro Store Cart';
      if (headerEl) headerEl.classList.add('drawer__header--astro');
    } else {
      headingEl.textContent = window.cartDrawerHeadingDefault || 'Your Cart';
      if (headerEl) headerEl.classList.remove('drawer__header--astro');
    }
  }
}

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);



/* ================================
   🔥 CONFIG
================================ */
const FREE_GIFT_VARIANT_ID_1 = 44074855727164; // Cotton Wicks
const FREE_GIFT_VARIANT_ID_2 = 45725013508156; // 7 Mukhi Rudraksha
const THRESHOLD_GIFT_1 = 54900; // ₹549
const THRESHOLD_GIFT_2 = 99900; // ₹999


/* ================================
   🎁 ADD / REMOVE FREE GIFT (ROBUST)
================================ */
async function checkFreeGift(cartData = null) {
  if (window.isUpdatingFreeGift) return;

  try {
    let cart = cartData;
    // If cartData doesn't look like a cart object or is missing items, fetch it.
    if (!cart || !cart.items) {
      console.log("Fetching latest cart for gift check...");
      cart = await fetch('/cart.js?v=' + new Date().getTime()).then(r => r.json());
    }

    // Update progress bar UI (using global function)
    if (typeof updateFreeGiftProgressBar === 'function') {
      updateFreeGiftProgressBar(cart);
    }

    const giftItem1 = cart.items.find(item => item.variant_id === FREE_GIFT_VARIANT_ID_1 && item.properties && (item.properties._free_gift === "true" || item.properties["_free_gift"] === "true"));
    const giftItem2 = cart.items.find(item => item.variant_id === FREE_GIFT_VARIANT_ID_2 && item.properties && (item.properties._free_gift === "true" || item.properties["_free_gift"] === "true"));

    // Eligible product IDs per milestone, scoped by the collection set in Theme Settings → Free Gift Offers.
    // An empty list means no collection was configured, so that milestone never qualifies.
    const eligibleIds1 = Array.isArray(window.freeGiftEligibleIds1) ? window.freeGiftEligibleIds1 : [];
    const eligibleIds2 = Array.isArray(window.freeGiftEligibleIds2) ? window.freeGiftEligibleIds2 : [];

    const qualifyingTotal = (eligibleIds) => cart.items.reduce((total, item) => {
      const isGift = item.properties && (item.properties._free_gift === "true" || item.properties["_free_gift"] === "true");
      if (isGift) return total;
      if (!eligibleIds.includes(item.product_id)) return total;
      return total + item.final_line_price;
    }, 0);

    const qualifyingTotal1 = qualifyingTotal(eligibleIds1);
    const qualifyingTotal2 = qualifyingTotal(eligibleIds2);

    const isIndia = window.localizationCountryCode === 'IN';
    const qualifies1 = isIndia && eligibleIds1.length > 0 && (qualifyingTotal1 >= THRESHOLD_GIFT_1);
    const qualifies2 = isIndia && eligibleIds2.length > 0 && (qualifyingTotal2 >= THRESHOLD_GIFT_2);

    console.log("Free Gift Check Status:", {
      qualifyingTotal1: qualifyingTotal1 / 100,
      qualifyingTotal2: qualifyingTotal2 / 100,
      qualifies1,
      qualifies2,
      gift1Found: giftItem1 ? "Yes" : "No",
      gift2Found: giftItem2 ? "Yes" : "No"
    });

    let itemsToAdd = [];
    let updatesToRemove = {};

    // Milestone 1 (₹549): Wicks Pack — only if NOT yet at Milestone 2
    if (qualifies1 && !qualifies2) {
      if (!giftItem1) {
        itemsToAdd.push({ id: FREE_GIFT_VARIANT_ID_1, quantity: 1, properties: { "_free_gift": "true" } });
      }
    } else {
      if (giftItem1) {
        updatesToRemove[giftItem1.key] = 0;
      }
    }

    // Milestone 2 (₹999): Rudraksha
    if (qualifies2) {
      if (!giftItem2) {
        itemsToAdd.push({ id: FREE_GIFT_VARIANT_ID_2, quantity: 1, properties: { "_free_gift": "true" } });
      }
    } else {
      if (giftItem2) {
        updatesToRemove[giftItem2.key] = 0;
      }
    }

    // Apply updates if there is any work to do
    if (itemsToAdd.length > 0 || Object.keys(updatesToRemove).length > 0) {
      window.isUpdatingFreeGift = true;
      let finalResult = null;

      // 1. Process removals first (if any)
      if (Object.keys(updatesToRemove).length > 0) {
        console.log("Automatically removing free gift(s)...", updatesToRemove);
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            updates: updatesToRemove,
            sections: "cart-drawer,cart-icon-bubble"
          })
        });
        finalResult = await response.json();
      }

      // 2. Process additions next (if any)
      if (itemsToAdd.length > 0) {
        console.log("Automatically adding free gift(s)...", itemsToAdd);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: itemsToAdd,
            sections: "cart-drawer,cart-icon-bubble"
          })
        });
        finalResult = await response.json();
      }

      // 3. Render contents
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && finalResult && finalResult.sections) {
        cartDrawer.renderContents({ id: finalResult.token, sections: finalResult.sections });
      }
      window.isUpdatingFreeGift = false;
    }

  } catch (err) {
    console.error("Free gift logic error:", err);
    window.isUpdatingFreeGift = false;
  }
}


/* ================================
   🚀 EVENTS
================================ */

console.log("Cart Drawer Free Gift Script Loaded");
window.isUpdatingFreeGift = false;

async function onCartUpdate(eventData) {
  console.log("Cart Update Event Received:", eventData);
  if (window.isUpdatingFreeGift) return;
  const cart = (eventData && eventData.cartData && eventData.cartData.items) ? eventData.cartData : null;
  await checkFreeGift(cart);
}

// Subscribe to cart updates
if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
  subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
}

// Page load check
document.addEventListener("DOMContentLoaded", () => {
  checkFreeGift();
  // Sync cart store type on page load
  fetch('/cart.js').then(r => r.json()).then(cart => syncCartStoreType(cart.items)).catch(() => {});
});

// Fallbacks for various cart actions
document.addEventListener("submit", function (e) {
  if (e.target.action && e.target.action.includes('/cart/add')) {
    setTimeout(() => checkFreeGift(), 1500);
  }
});

// Extra listener for remove buttons and quantity buttons
document.addEventListener("click", function (e) {
  const target = e.target.closest('.cart-remove-button, .quantity__button');
  if (target) {
    console.log("Cart interaction detected (Click), scheduling robust checks...");
    // Multiple checks to handle server-side processing time
    setTimeout(() => checkFreeGift(), 500);
    setTimeout(() => checkFreeGift(), 1500);
    setTimeout(() => checkFreeGift(), 3000);
  }
});

// Update for quantity input changes
document.addEventListener("change", function (e) {
  if (e.target.matches('.quantity__input')) {
    console.log("Quantity change detected, scheduling robust checks...");
    setTimeout(() => checkFreeGift(), 500);
    setTimeout(() => checkFreeGift(), 2000);
  }
});